import { Inject, Injectable } from "@angular/core";
import { AbstractService } from "./abstract-service.service";
import { Brand } from "../Models/brand";
import { HttpClient, HttpParams } from "@angular/common/http";
import { APP_CONFIG, AppConfig } from "./config";
import { Observable } from "rxjs";
import { Response } from "../Models/response";

@Injectable({
  providedIn: "root",
})
export class BrandService extends AbstractService<Brand, number> {
  url: string;

  constructor(
    protected http: HttpClient,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {
    super(http);
    this.url = `${this.appConfig.apiEndpoint}/new/brands`;
  }

  public getByCategoryId(id: number[], inStock: string): Observable<Brand[]> {
    const options = {
      params: new HttpParams()
        .append("id", id.toString())
        .append("inStock", inStock),
    };
    const url = `${this.url}/categories`;
    return this.http.get<Brand[]>(url, options);
  }
}
